import { message } from "antd";
import { UploadRequestOption } from "rc-upload/lib/interface";
import { ReactElement, useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { IDeleteDocumentHandlerProps } from "../../../../interfaces/props/IDeleteDocumentHandlerProps";
import { IDownloadDocumentHandlerProps } from "../../../../interfaces/props/IDownloadDocumentHandlerProps";
import { API_CENTER } from "../../../../services/api/api";
import { useDeleteDocumentApplicationMutation } from "../../../../store/api/application.api";
import { useAppDispatch, useAppSelector } from "../../../../store/reduxHooks";
import { SELECT_REQUEST_DOCUMENTS } from "../../../../store/selectors/requestAppSelector";
import {
  DELETE_DOCUMENT,
  SEARCH_UP_DATA_DOCUMENTS_ID,
} from "../../../../store/slice/requestAppSlise/requestAppSlise";
import { DownloadingFiles } from "../../../../utils/utilities/Downloads";
import { validateFile } from "../../../../utils/utilities/validateFile";
import DocCard from "../DocCard/DocCard";
import { DocNewFile } from "./DocNewFile";

import classes from "./style/DocRequestList.module.css";

// список документов от сервера
export function DocRequestList(): ReactElement {
  const documents = useAppSelector(SELECT_REQUEST_DOCUMENTS);
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState<string[]>([]);
  const [isUploadingDocument, setIsUploadingDocument] = useState<boolean[]>([]);
  const [deleteDocument] = useDeleteDocumentApplicationMutation();

  function updateError(index: number, error: string) {
    setErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = error;
      return newErrors;
    });
  }

  function changeIsUploadDocument(index: number) {
    setIsUploadingDocument((prevUploadState) => {
      const isUploadArray = [...prevUploadState];
      isUploadArray[index] = !prevUploadState[index];
      return isUploadArray;
    });
  }

  const deleteDocumentCallback = useCallback(
    ({ id, document_id }: IDeleteDocumentHandlerProps) => {
      if (id && document_id) {
        deleteDocument({ id: document_id })
          .unwrap()
          .then(() => {
            dispatch(DELETE_DOCUMENT(id));
            message.success("Документ удалён");
          })
          .catch(() => {
            message.error("Не удалось удалить документ");
          });
      } else {
        message.info("Документ не загружен");
      }
    },
    [deleteDocument, dispatch],
  );

  const uploadDocumentCallback = useCallback(
    (options: UploadRequestOption, index: number) => {
      const { file } = options;

      const { isValidate, error } = validateFile(file as File);
      if (isValidate) {
        const formFileData = new FormData();
        const API = new API_CENTER();
        if (documents[index].document) {
          if (documents[index]?.document?.bank_id) {
            formFileData.append(
              "bank_id",
              `${documents[index]?.document?.bank_id}`,
            );
          }
          formFileData.append("file", file);
          changeIsUploadDocument(index);
          API.GET_API(
            `file/${documents[index]?.document?.id}/update`,
            "POST",
            formFileData,
          )
            .then((res) => {
              if (res.success) {
                dispatch(
                  SEARCH_UP_DATA_DOCUMENTS_ID({
                    document: res.data,
                    id: documents[index].id,
                  }),
                );
                // необходимо искать файлы если есть и заменять их данные по idex
              }
              formFileData.delete("type_doc_id");
              formFileData.delete("file");
              formFileData.delete("bank_id");
            })
            .finally(() => {
              formFileData.delete("type_doc_id");
              formFileData.delete("file");
              formFileData.delete("bank_id");

              changeIsUploadDocument(index);
            });
        } else {
          formFileData.append("type_doc_id", `${documents[index]?.id}`);
          formFileData.append("file", file);

          changeIsUploadDocument(index);
          API.GET_API(`file/${id}`, "POST", formFileData)
            .then((res) => {
              if (res.success) {
                // необходимо искать файлы по id изучить какое подойдет
                dispatch(
                  SEARCH_UP_DATA_DOCUMENTS_ID({
                    document: res.data,
                    id: documents[index]?.id,
                  }),
                );
              }
              formFileData.delete("type_doc_id");
              formFileData.delete("file");
              formFileData.delete("bank_id");
            })
            .finally(() => {
              formFileData.delete("type_doc_id");
              formFileData.delete("file");
              formFileData.delete("bank_id");

              changeIsUploadDocument(index);
            });
        }
        updateError(index, "");
      } else {
        updateError(index, error ? error : "");
      }
    },
    [dispatch, documents, id],
  );

  const downloadDocumentCallback = useCallback(
    ({ name, document_id }: IDownloadDocumentHandlerProps) => {
      if (name && document_id) {
        const urlFile = {
          url: "auth/file/" + document_id,
          fileName: `${name}`,
        };
        DownloadingFiles(urlFile);
      }
    },
    [],
  );

  return (
    <div className={classes.documentListContainer}>
      <div className={classes.documentList}>
        {Array.isArray(documents) &&
          documents?.map((item, index) => {
            return (
              <DocCard
                key={item.id}
                item={item}
                index={index}
                error={errors[index]}
                isUploadingDocument={isUploadingDocument[index]}
                uploadDocumentCallback={uploadDocumentCallback}
                deleteDocumentCallback={deleteDocumentCallback}
                downloadDocumentCallback={downloadDocumentCallback}
              />
            );
          })}
      </div>
      <div className={classes.buttonAddDocument}>
        <DocNewFile />
      </div>
    </div>
  );
}
